import React from 'react'
import Loadable from 'react-loadable'
import Loading from '../../components/loader/Loader'
import RolesEnum from '../../Enum/RolesEnum';

const PedidosComponent = Loadable({
  loader: () => import('../../../pages/pedidos/Pedidos'),
  loading: () => <Loading />
})

const PedidosOperacao = Loadable({
  loader: () => import('../../../pages/operacaolista/Pedidos'),
  loading: () => <Loading />
})

export default [
  {
    path: '/pedidos',
    title: 'Pedidos',
    component: PedidosComponent,
    isAuthenticated: true,
    roles: [RolesEnum.Organizacao]
  },
  {
    path: '/operacao/pedidos/:statusId/:date',
    title: 'Pedidos Operação',
    component: PedidosOperacao,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  }
]
